@if (attachments) {
<div class="pia-attachmentsBlock">
  <p>{{ "pia.attachments.title" | translate }}</p>
  @if (attachments.length > 0) { @for (attachment of attachments; track
  attachment; let i = $index) {
  <app-attachment-item
    [editMode]="editMode"
    [attachment]="attachment"
    (deleted)="onDeleted($event)"
    [isPreview]="isPreview"
    [pia]="pia"
  >
  </app-attachment-item>
  } } @else {
  <p>
    <small>{{ "pia.attachments.no_attachment" | translate }}</small>
  </p>
  } @if (!isPreview && attachments) {
  <form enctype="multipart/form-data" [formGroup]="attachmentForm">
    <input
      type="file"
      formControlName="attachment_file"
      id="attachment_file"
      (change)="uploadAttachement($event)"
      class="hide"
    />
    @if ( ['author', 'validator', 'evaluator'].indexOf(editMode[0]) >= 0 ||
    editMode === 'local' ) {
    <button
      class="pia-attachmentsBlock-addBtn btn"
      [disabled]="loading"
      [ngClass]="{ hide: !dispplayAttachmentButton }"
      type="button"
      (click)="addAttachment()"
    >
      @if (!loading) {
      <span class="pia-icons pia-icon-add"></span>
      {{ "pia.attachments.add" | translate }}
      } @else {
      {{ "pia.attachments.loading" | translate }}
      }
    </button>
    }
  </form>
  }
</div>
}
